/* src/app/global/components/global-help/global-help-details/global-help-details.component.scss */
:host ::ng-deep phscw-toolbar {
  margin-top: 5px;
}
:host .cw-flex-column {
  height: 100%;
}
:host .cw-module {
  height: 100%;
  overflow-y: auto;
}
/*# sourceMappingURL=global-help-details.component.css.map */
